export enum PhoneNumberType {
  None = 0,
  Business = 1,
  Personal = 2,
  Fax = 3,
  Mobile = 4
}
